import { render, staticRenderFns } from "./issues-change.vue?vue&type=template&id=548c4a85&scoped=true&"
import script from "./issues-change.vue?vue&type=script&lang=js&"
export * from "./issues-change.vue?vue&type=script&lang=js&"
import style0 from "./issues-change.vue?vue&type=style&index=0&lang=css&"
import style1 from "./issues-change.vue?vue&type=style&index=1&id=548c4a85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548c4a85",
  null
  
)

export default component.exports